/**
 * Tipos de campo personalizado aceitos no formulário PÚBLICO de captação.
 *
 * Importado por:
 *   - Backend: `server/routes/public-captacao.ts` (decide o que o
 *     `GET /form-config` expõe e o que o `POST /lead` aceita)
 *   - Frontend: `src/pages/admin/custom-fields/CampoBuilderDialog.tsx`
 *     (avisa o admin quando o tipo escolhido não vai aparecer na captação)
 *     via alias `@server-types/custom-fields-publico`
 *
 * PORQUÊ existir: até a rodada K-01 o backend público tinha um SEGUNDO
 * vocabulário de tipo (`text | number | select | boolean`) traduzido a partir
 * do canônico, e o construtor tinha a sua própria cópia da lista. Dois
 * vocabulários + duas listas = cada lado podia crescer sozinho e o outro nem
 * ficava sabendo — foi exatamente assim que o construtor passou a oferecer
 * tipos que o formulário público não desenhava.
 *
 * REGRA: esta lista é SUBCONJUNTO do vocabulário canônico (os valores do CHECK
 * de `custom_fields.tipo`), nunca um dialeto. Se um valor aqui deixar de bater
 * com o canônico, o campo simplesmente some do formulário público sem erro
 * nenhum — falha silenciosa, a pior de todas.
 *
 * Pra liberar um tipo novo no público, os três precisam valer:
 *   1. o `DynamicForm` sabe desenhar o tipo;
 *   2. `validarCamposCustom` (public-captacao.ts) sabe validar/sanitizar;
 *   3. o tipo não expõe dado interno nem exige upload.
 * Só então ele entra nesta lista.
 */

export const PUBLIC_SUPPORTED_TIPOS = ['text', 'number', 'dropdown', 'checkbox'] as const;

export type PublicSupportedTipo = (typeof PUBLIC_SUPPORTED_TIPOS)[number];

/** Narrowing pro tipo canônico gravado no banco (string crua vinda do SQLite). */
export function isTipoPublico(tipo: string): tipo is PublicSupportedTipo {
  return (PUBLIC_SUPPORTED_TIPOS as ReadonlyArray<string>).includes(tipo);
}
